<template lang="pug">
  container(:width="row.width")
    //- TODO figure out hide/show on touch
    figure.video-player(:class="{'relative': !fullscreen, 'video-player--full fixed z-40 inset-0 h-screen w-full bg-black flex items-center justify-center': fullscreen, 'video-player--full--no-controls': !fullscreenBtn}", @mousemove="onMouseMove", @touchstart="onTouch")
      //- video
      video.w-full.outline-none(ref="video", v-if="bestSrc", :src="bestSrc[1]", :poster="media.poster", playsinline, controlslist="nodownload", loop, @pause="onPause", @play="onPlay", @contextmenu.prevent, @timeupdate="onTimeupdate", @mute="muted = true", @unmute="muted = false", :class="{'absolute inset-0 top-40 h-full_-80 object-contain object-center': fullscreen}")
      //- controls
      transition(name="fade")
        nav(v-show="!controlsTouchHidden")
          //- play/pause
          .absolute.w-full.inset-0.flex.items-center.justify-center
            button.w-40.h-40(:aria-label="paused ? 'Play' : 'Pause'", :disabled="!canplay", @click="togglePlay", :class="{'opacity-25': !canplay}")
              img.block.w-full.select-none(src="@/assets/icons/play--encircled.svg", v-show="paused")
              img.block.w-full.select-none(src="@/assets/icons/pause--encircled.svg", v-show="!paused")
          .absolute.z-10.w-full.bottom-0.left-0.flex.items-center.justify-between.pt-10
            button.px-15.py-10.select-none(@click="toggleMute")
              img.block(src="@/assets/icons/sound-off.svg", v-show="muted", style="width:2.2rem")
              img.block(src="@/assets/icons/sound-on.svg", v-show="!muted", style="width:2.2rem")
            progress.flex-1.h-2.py-10.content-box.cursor-pointer(max="100", :value="prgrss", @click="onProgressClick")
            //- btn: fullscreen
            button.px-15(@click="toggleFullscreen", aria-label="Toggle Fullscreen")
              img.block.w-20(v-show="!fullscreen", src="@/assets/icons/full-screen.svg")
              img.block.w-20(v-show="fullscreen", src="@/assets/icons/full-screen--off.svg")
</template>

<script>
import { mapState } from 'vuex'
import Container from '@/components/Container'
import _throttle from 'lodash/throttle'
import { toggleiOSVideoFull } from '@/utils'
export default {
  name: 'VideoPlayer',
  props: ['row'],
  data () {
    return {
      media: null,
      canplay: true,
      paused: true,
      muted: false,
      prgrss: 0,

      elW: 0,
      dpx: window.devicePixelRatio || 1,

      fullscreen: false, // fullscreen mode
      lastY: 0,
      afterMouse: null,
      fullscreenBtn: true,
      controlsTouchHidden: false,
      controlsTouchTmOut: null
    }
  },
  computed: {
    ...mapState(['canHover']),
    aspectRatio () {
      const details = this.media && this.media.media_details
      return details && details.width && details.height && details.height / details.width
    },
    bestSrc () {
      if (!this.aspectRatio || !this.media) return null
      const srcs = this.media.sources
      // target height
      const h = this.elW * this.aspectRatio * this.dpx * 0.85
      // find source bigger than target h
      const best = srcs.find(src => src[0] >= h)
      // best or fallbacks
      return best || (srcs.length && srcs[srcs.length - 1]) || [null, this.media.source_url]
    }
  },
  methods: {
    togglePlay () {
      if (this.$refs.video.paused) return this.$refs.video.play()
      return this.$refs.video.pause()
    },
    onPlay () {
      this.paused = false
      this.hideTouchControls()
    },
    onPause () {
      this.paused = true
      this.showTouchControls()
    },
    toggleMute () {
      this.$refs.video.muted = this.muted = !this.$refs.video.muted
    },
    onTimeupdate () {
      if (!this.$refs.video) return
      this.prgrss = this.$refs.video.currentTime / this.$refs.video.duration * 100
    },
    onProgressClick (e) {
      const vid = this.$refs.video
      if (!vid) return
      const pct = e.offsetX / e.target.offsetWidth
      vid.currentTime = pct * vid.duration
    },
    toggleFullscreen () {
      // ios ?
      const ios = toggleiOSVideoFull(this.$refs.video)
      if (ios) return
      // default
      if (!this.fullscreen) {
        this.lastY = window.pageYOffset
        this.fullscreen = true
        // this.measure()
      } else {
        this.fullscreen = false
        this.$nextTick(() => window.scroll(0, this.lastY))
      }
    },
    onMouseMove: _throttle(function () {
      clearTimeout(this.afterMouse)
      this.fullscreenBtn = true
      if (!this.fullscreen) return
      // in fullscreen...
      this.afterMouse = setTimeout(() => {
        this.fullscreenBtn = false
      }, 1500)
    }, 50),
    showTouchControls () {
      clearTimeout(this.controlsTouchTmOut)
      this.controlsTouchHidden = false
    },
    hideTouchControls (delay = 2000) {
      this.showTouchControls()
      if (this.canHover || this.paused) return
      this.controlsTouchTmOut = setTimeout(() => {
        this.controlsTouchHidden = true
      }, delay)
    },
    onTouch () {
      this.hideTouchControls()
    },
    onKeyStroke (e) {
      return (e.key === 'Escape' || e.keyCode === 27) && this.toggleFullscreen()
    },
    measure () {
      this.elW = this.$el.offsetWidth
    }
  },
  created () {
    this.$store.dispatch('getMedia', { id: this.row.video_file, wpnonce: this.$route.query.preview })
      .then(media => { this.media = media })
  },
  mounted () {
    this.measure()
  },
  watch: {
    fullscreen (full) {
      if (full) return window.addEventListener('keydown', this.onKeyStroke)
      return window.removeEventListener('keydown', this.onKeyStroke)
    }
  },
  components: { Container }
}
</script>

<style>
/* on hover */
@media (hover:hover) {
  .video-player {
    /* hiding */
    & nav,
    &.video-player--full.video-player--full--no-controls nav{
      opacity:0;
      visibility: hidden;
      transition: opacity 400ms, visibility 0s 400ms;
    }
    /* showing */
    &:hover nav{
      opacity:1;
      visibility: visible;
      transition: opacity 400ms, visibility 0s;
    }
  }
}

/* style video progress bar */
.video-player progress{
  appearance:none;
  &[value]::-webkit-progress-bar{
    background: var(--black);
  }
  &[value]::-webkit-progress-value{
    background:var(--white);
  }
}
</style>
